import store from '../store/index.js'
let http = {
	wsUrl:'ws://106.13.30.94:2346'
}
let isSocketClose = false; // 是否关闭socket
let heartbeatInterval = ""; // 心跳定时器
let socketTask = null;

let againTimer = null; //断线重连定时器


let url = null;
let onReFn = null;
let onSucFn = null;
let onErrFn = null;

/**
 * sockeUrl：websocet的地址
 * onReceive：消息监听的回调
 * onErrorEvent：抛出错误的回调，且弹窗连接失败的提示框
 * onErrorSucceed：抛出成功回调，主要用于隐藏连接失败的提示框
 * */
const sokcet = (onReceive, onErrorEvent, onErrorSucceed) => {
	url = http.wsUrl;
	onReFn = onReceive;
	onErrFn = onErrorEvent;
	onSucFn = onErrorSucceed;
	isSocketClose = false;
	//判断是否有websocet对象，有的话清空
	if (socketTask) {
		socketTask.close();
		socketTask = null;
		clearInterval(heartbeatInterval);
	}
	//≈
	let loginShow = uni.getStorageSync('access_token');
	//判断是否登录，只有登录了，才能往下走
	if (!loginShow) {
		clearInterval(heartbeatInterval);
		clearInterval(againTimer) //断线重连定时器
		return
	};
	//WebSocket的地址
	// 【非常重要】必须确保你的服务器是成功的,如果是手机测试千万别使用ws://127.0.0.1:9099【特别容易犯的错误】
	let url = http.wsUrl
	// 连接
	socketTask = uni.connectSocket({
		url: url,
		success(data) {
			console.log("websocket连接成功");
			clearInterval(againTimer) //断线重连定时器
		},
		fail: (err) => {
			console.log("报错", err);
		}
	});

	// 连接打开
	socketTask.onOpen((res) => {
		console.log('WebSocket打开');
		sendMsg({
			type:'register'
		})
		clearInterval(againTimer) //断线重连定时器
		heartbeatInterval && clearInterval(heartbeatInterval);
		// 10秒发送一次心跳
		heartbeatInterval = setInterval(() => {
			sendMsg({
				type:'register'
			})
		}, 1000 * 5)
	})
	// 监听连接失败
	socketTask.onError((err) => {
		console.log('WebSocket连接打开失败，请检查', err);
		//停止发送心跳
		clearInterval(heartbeatInterval)
		//如果不是人为关闭的话，进行重连
		if (!isSocketClose) {
			reconnect(url, onErrorEvent)
		}
	})

	// // 监听连接关闭 -
	socketTask.onClose((e) => {
		console.log('WebSocket连接关闭！');
		clearInterval(heartbeatInterval)
		if (!isSocketClose) {
			reconnect(url, onErrorEvent)
		}
	})

	// 监听收到信息
	socketTask.onMessage((res) => {
		console.log(res, 'res监听收到信息')
		let serverData = res.data
		//与后端规定好返回值分别代表什么，写业务逻辑
		//store.commit('getmessageFn', JSON.parse(serverData))
		// serverData && onReceive(serverData);
	});
}

const reconnect = () => {
	console.log('进入断线重连', isSocketClose);
	clearInterval(againTimer) //断线重连定时器
	clearInterval(heartbeatInterval);
	try {
		if (socketTask.close && typeof(socketTask.close) == "function") {
			socketTask.close({
				success(res) {
					console.log("关闭成功", res)
				},
				fail(err) {
					console.log("关闭失败", err)
				}
			})
		}
	} catch (e) {
		console.log('------没有close方法---' + e);
		// 连接  重新调用创建websocet方法
	}
	socketTask = null;
	againTimer = setInterval(() => {
		sokcet(url, onReFn, onErrFn, onSucFn)
		console.log('在重新连接中...');
	}, 1000 * 5)
}

const sendMsg = (msg) => { //向后端发送命令
	msg = JSON.stringify(msg);
	//console.log(msg);
	try {
		//通过 WebSocket 连接发送数据
		socketTask.send({
			data: msg,
			async success() {
				console.warn("------------------消息发送成功");
				//console.log(JSON.parse(msg))
			},
		});
	} catch (e) {
		console.log('1111111');
		socketTask.close({
			success(res) {
				console.log("关闭成功", res)
			},
			fail(err) {
				console.log("关闭失败", err)
			}
		})

	}
}
// 关闭websocket【必须在实例销毁之前关闭,否则会是underfined错误】beforeDestroy() {websocetObj.stop();}

const stop = () => {
	clearInterval(heartbeatInterval);
	clearInterval(againTimer) //断线重连定时器
	socketTask.close(); // 确保已经关闭后再重新打开
	socketTask = null;
	isSocketClose = true;
	console.log('关闭成功');
}


const $debounce = function(fn, wait) {
	let timer = null;
	return function() {
		if (timer !== null) {
			clearTimeout(timer);
		}
		timer = setTimeout(fn, wait);
	}
}


export const websocetObj = {
	sokcet,
	stop,
	sendMsg,
	reconnect
};
